import accordionEn from "./en/accordion.json";
import alertEn from "./en/alert.json";
import animatedIconEn from "./en/animatedIcon.json";
import areaChartEn from "./en/areaChart.json";
import aspectRatioEn from "./en/aspectRatio.json";
import attachmentEn from "./en/attachment.json";
import avatarEn from "./en/avatar.json";
import avatarGroupEn from "./en/avatarGroup.json";
import badgeEn from "./en/badge.json";
import barChartEn from "./en/barChart.json";
import bottomSheetEn from "./en/bottomSheet.json";
import brandIconsEn from "./en/brandIcons.json";
import breadcrumbEn from "./en/breadcrumb.json";
import bubbleEn from "./en/bubble.json";
import buttonEn from "./en/button.json";
import buttonGroupEn from "./en/buttonGroup.json";
import cardEn from "./en/card.json";
import carouselEn from "./en/carousel.json";
import chartEn from "./en/chart.json";
import checkBoxEn from "./en/checkBox.json";
import chipEn from "./en/chip.json";
import citationEn from "./en/citation.json";
import codeEditorEn from "./en/codeEditor.json";
import codeViewerEn from "./en/codeViewer.json";
import collapsibleEn from "./en/collapsible.json";
import colorAreaEn from "./en/colorArea.json";
import colorFieldEn from "./en/colorField.json";
import colorPickerEn from "./en/colorPicker.json";
import colorSliderEn from "./en/colorSlider.json";
import colorSwatchEn from "./en/colorSwatch.json";
import colorSwatchPickerEn from "./en/colorSwatchPicker.json";
import comboboxEn from "./en/combobox.json";
import commandEn from "./en/command.json";
import composerEn from "./en/composer.json";
import contextMenuEn from "./en/contextMenu.json";
import dataTableEn from "./en/dataTable.json";
import dateSelectorEn from "./en/dateSelector.json";
import dateTimePickerEn from "./en/dateTimePicker.json";
import dateTimeSheetEn from "./en/dateTimeSheet.json";
import dialogEn from "./en/dialog.json";
import directionProviderEn from "./en/directionProvider.json";
import dropdownMenuEn from "./en/dropdownMenu.json";
import embeddedMenuEn from "./en/embeddedMenu.json";
import emptyEn from "./en/empty.json";
import fieldEn from "./en/field.json";
import fileUploadEn from "./en/fileUpload.json";
import flagEn from "./en/flag.json";
import headerEn from "./en/header.json";
import highlightButtonEn from "./en/highlightButton.json";
import hoverCardEn from "./en/hoverCard.json";
import iconEn from "./en/icon.json";
import inputGroupEn from "./en/inputGroup.json";
import inputOTPEn from "./en/inputOTP.json";
import itemEn from "./en/item.json";
import kbdEn from "./en/kbd.json";
import labelEn from "./en/label.json";
import lineChartEn from "./en/lineChart.json";
import loadingEn from "./en/loading.json";
import localeSwitcherEn from "./en/localeSwitcher.json";
import mainHeaderEn from "./en/mainHeader.json";
import markdownEditorEn from "./en/markdownEditor.json";
import markdownViewerEn from "./en/markdownViewer.json";
import markerEn from "./en/marker.json";
import menuEn from "./en/menu.json";
import menubarEn from "./en/menubar.json";
import messageEn from "./en/message.json";
import messageScrollerEn from "./en/messageScroller.json";
import modalEn from "./en/modal.json";
import monthSelectorEn from "./en/monthSelector.json";
import nativeSelectEn from "./en/nativeSelect.json";
import navigationMenuEn from "./en/navigationMenu.json";
import notificationIndicatorEn from "./en/notificationIndicator.json";
import numericInputEn from "./en/numericInput.json";
import pageContainerEn from "./en/pageContainer.json";
import paginationEn from "./en/pagination.json";
import paletteSwitcherEn from "./en/paletteSwitcher.json";
import pieChartEn from "./en/pieChart.json";
import popoverEn from "./en/popover.json";
import progressEn from "./en/progress.json";
import questionnaireEn from "./en/questionnaire.json";
import radarChartEn from "./en/radarChart.json";
import radialChartEn from "./en/radialChart.json";
import radioButtonEn from "./en/radioButton.json";
import radioGroupEn from "./en/radioGroup.json";
import resizableEn from "./en/resizable.json";
import rowCardEn from "./en/rowCard.json";
import scrollAreaEn from "./en/scrollArea.json";
import selectBoxEn from "./en/selectBox.json";
import selectSheetEn from "./en/selectSheet.json";
import separatorEn from "./en/separator.json";
import sheetEn from "./en/sheet.json";
import sidebarEn from "./en/sidebar.json";
import siteLogoEn from "./en/siteLogo.json";
import skeletonEn from "./en/skeleton.json";
import sliderEn from "./en/slider.json";
import snackBarEn from "./en/snackBar.json";
import sparklineEn from "./en/sparkline.json";
import stateCardEn from "./en/stateCard.json";
import statTileEn from "./en/statTile.json";
import stepperEn from "./en/stepper.json";
import stickerEn from "./en/sticker.json";
import swipeableRowEn from "./en/swipeableRow.json";
import systemToolbarEn from "./en/systemToolbar.json";
import tabBarEn from "./en/tabBar.json";
import tableEn from "./en/table.json";
import tabsEn from "./en/tabs.json";
import textEn from "./en/text.json";
import textAreaInputEn from "./en/textAreaInput.json";
import textInputEn from "./en/textInput.json";
import themeSwitcherEn from "./en/themeSwitcher.json";
import timelineEn from "./en/timeline.json";
import timeSelectorEn from "./en/timeSelector.json";
import toastEn from "./en/toast.json";
import toggleEn from "./en/toggle.json";
import toggleGroupEn from "./en/toggleGroup.json";
import tooltipEn from "./en/tooltip.json";
import traceEn from "./en/trace.json";
import treeViewEn from "./en/treeView.json";
import userShortcutEn from "./en/userShortcut.json";
import webScrollbarEn from "./en/webScrollbar.json";
import yearSelectorEn from "./en/yearSelector.json";
import accordionTr from "./tr/accordion.json";
import alertTr from "./tr/alert.json";
import animatedIconTr from "./tr/animatedIcon.json";
import areaChartTr from "./tr/areaChart.json";
import aspectRatioTr from "./tr/aspectRatio.json";
import attachmentTr from "./tr/attachment.json";
import avatarTr from "./tr/avatar.json";
import avatarGroupTr from "./tr/avatarGroup.json";
import badgeTr from "./tr/badge.json";
import barChartTr from "./tr/barChart.json";
import bottomSheetTr from "./tr/bottomSheet.json";
import brandIconsTr from "./tr/brandIcons.json";
import breadcrumbTr from "./tr/breadcrumb.json";
import bubbleTr from "./tr/bubble.json";
import buttonTr from "./tr/button.json";
import buttonGroupTr from "./tr/buttonGroup.json";
import cardTr from "./tr/card.json";
import carouselTr from "./tr/carousel.json";
import chartTr from "./tr/chart.json";
import checkBoxTr from "./tr/checkBox.json";
import chipTr from "./tr/chip.json";
import citationTr from "./tr/citation.json";
import codeEditorTr from "./tr/codeEditor.json";
import codeViewerTr from "./tr/codeViewer.json";
import collapsibleTr from "./tr/collapsible.json";
import colorAreaTr from "./tr/colorArea.json";
import colorFieldTr from "./tr/colorField.json";
import colorPickerTr from "./tr/colorPicker.json";
import colorSliderTr from "./tr/colorSlider.json";
import colorSwatchTr from "./tr/colorSwatch.json";
import colorSwatchPickerTr from "./tr/colorSwatchPicker.json";
import comboboxTr from "./tr/combobox.json";
import commandTr from "./tr/command.json";
import composerTr from "./tr/composer.json";
import contextMenuTr from "./tr/contextMenu.json";
import dataTableTr from "./tr/dataTable.json";
import dateSelectorTr from "./tr/dateSelector.json";
import dateTimePickerTr from "./tr/dateTimePicker.json";
import dateTimeSheetTr from "./tr/dateTimeSheet.json";
import dialogTr from "./tr/dialog.json";
import directionProviderTr from "./tr/directionProvider.json";
import dropdownMenuTr from "./tr/dropdownMenu.json";
import embeddedMenuTr from "./tr/embeddedMenu.json";
import emptyTr from "./tr/empty.json";
import fieldTr from "./tr/field.json";
import fileUploadTr from "./tr/fileUpload.json";
import flagTr from "./tr/flag.json";
import headerTr from "./tr/header.json";
import highlightButtonTr from "./tr/highlightButton.json";
import hoverCardTr from "./tr/hoverCard.json";
import iconTr from "./tr/icon.json";
import inputGroupTr from "./tr/inputGroup.json";
import inputOTPTr from "./tr/inputOTP.json";
import itemTr from "./tr/item.json";
import kbdTr from "./tr/kbd.json";
import labelTr from "./tr/label.json";
import lineChartTr from "./tr/lineChart.json";
import loadingTr from "./tr/loading.json";
import localeSwitcherTr from "./tr/localeSwitcher.json";
import mainHeaderTr from "./tr/mainHeader.json";
import markdownEditorTr from "./tr/markdownEditor.json";
import markdownViewerTr from "./tr/markdownViewer.json";
import markerTr from "./tr/marker.json";
import menuTr from "./tr/menu.json";
import menubarTr from "./tr/menubar.json";
import messageTr from "./tr/message.json";
import messageScrollerTr from "./tr/messageScroller.json";
import modalTr from "./tr/modal.json";
import monthSelectorTr from "./tr/monthSelector.json";
import nativeSelectTr from "./tr/nativeSelect.json";
import navigationMenuTr from "./tr/navigationMenu.json";
import notificationIndicatorTr from "./tr/notificationIndicator.json";
import numericInputTr from "./tr/numericInput.json";
import pageContainerTr from "./tr/pageContainer.json";
import paginationTr from "./tr/pagination.json";
import paletteSwitcherTr from "./tr/paletteSwitcher.json";
import pieChartTr from "./tr/pieChart.json";
import popoverTr from "./tr/popover.json";
import progressTr from "./tr/progress.json";
import questionnaireTr from "./tr/questionnaire.json";
import radarChartTr from "./tr/radarChart.json";
import radialChartTr from "./tr/radialChart.json";
import radioButtonTr from "./tr/radioButton.json";
import radioGroupTr from "./tr/radioGroup.json";
import resizableTr from "./tr/resizable.json";
import rowCardTr from "./tr/rowCard.json";
import scrollAreaTr from "./tr/scrollArea.json";
import selectBoxTr from "./tr/selectBox.json";
import selectSheetTr from "./tr/selectSheet.json";
import separatorTr from "./tr/separator.json";
import sheetTr from "./tr/sheet.json";
import sidebarTr from "./tr/sidebar.json";
import siteLogoTr from "./tr/siteLogo.json";
import skeletonTr from "./tr/skeleton.json";
import sliderTr from "./tr/slider.json";
import snackBarTr from "./tr/snackBar.json";
import sparklineTr from "./tr/sparkline.json";
import stateCardTr from "./tr/stateCard.json";
import statTileTr from "./tr/statTile.json";
import stepperTr from "./tr/stepper.json";
import stickerTr from "./tr/sticker.json";
import swipeableRowTr from "./tr/swipeableRow.json";
import systemToolbarTr from "./tr/systemToolbar.json";
import tabBarTr from "./tr/tabBar.json";
import tableTr from "./tr/table.json";
import tabsTr from "./tr/tabs.json";
import textTr from "./tr/text.json";
import textAreaInputTr from "./tr/textAreaInput.json";
import textInputTr from "./tr/textInput.json";
import themeSwitcherTr from "./tr/themeSwitcher.json";
import timelineTr from "./tr/timeline.json";
import timeSelectorTr from "./tr/timeSelector.json";
import toastTr from "./tr/toast.json";
import toggleTr from "./tr/toggle.json";
import toggleGroupTr from "./tr/toggleGroup.json";
import tooltipTr from "./tr/tooltip.json";
import traceTr from "./tr/trace.json";
import treeViewTr from "./tr/treeView.json";
import userShortcutTr from "./tr/userShortcut.json";
import webScrollbarTr from "./tr/webScrollbar.json";
import yearSelectorTr from "./tr/yearSelector.json";

export const COMPONENT_DICTIONARIES: Record<"tr" | "en", Record<string, string>> = {
    en: {
        ...accordionEn,
        ...alertEn,
        ...animatedIconEn,
        ...areaChartEn,
        ...aspectRatioEn,
        ...attachmentEn,
        ...avatarEn,
        ...avatarGroupEn,
        ...barChartEn,
        ...bottomSheetEn,
        ...brandIconsEn,
        ...breadcrumbEn,
        ...bubbleEn,
        ...buttonEn,
        ...buttonGroupEn,
        ...cardEn,
        ...carouselEn,
        ...chartEn,
        ...checkBoxEn,
        ...chipEn,
        ...citationEn,
        ...codeEditorEn,
        ...codeViewerEn,
        ...collapsibleEn,
        ...colorAreaEn,
        ...colorFieldEn,
        ...colorPickerEn,
        ...colorSliderEn,
        ...colorSwatchEn,
        ...colorSwatchPickerEn,
        ...comboboxEn,
        ...commandEn,
        ...composerEn,
        ...contextMenuEn,
        ...dataTableEn,
        ...dateSelectorEn,
        ...dateTimePickerEn,
        ...dateTimeSheetEn,
        ...dialogEn,
        ...directionProviderEn,
        ...dropdownMenuEn,
        ...embeddedMenuEn,
        ...fieldEn,
        ...fileUploadEn,
        ...flagEn,
        ...headerEn,
        ...highlightButtonEn,
        ...hoverCardEn,
        ...iconEn,
        ...itemEn,
        ...inputGroupEn,
        ...inputOTPEn,
        ...kbdEn,
        ...lineChartEn,
        ...loadingEn,
        ...localeSwitcherEn,
        ...mainHeaderEn,
        ...markdownEditorEn,
        ...markdownViewerEn,
        ...markerEn,
        ...menuEn,
        ...menubarEn,
        ...messageEn,
        ...messageScrollerEn,
        ...modalEn,
        ...monthSelectorEn,
        ...nativeSelectEn,
        ...navigationMenuEn,
        ...notificationIndicatorEn,
        ...numericInputEn,
        ...pageContainerEn,
        ...paginationEn,
        ...paletteSwitcherEn,
        ...pieChartEn,
        ...radarChartEn,
        ...radialChartEn,
        ...sparklineEn,
        ...popoverEn,
        ...progressEn,
        ...questionnaireEn,
        ...radioButtonEn,
        ...resizableEn,
        ...radioGroupEn,
        ...badgeEn,
        ...labelEn,
        ...emptyEn,
        ...scrollAreaEn,
        ...rowCardEn,
        ...selectBoxEn,
        ...selectSheetEn,
        ...separatorEn,
        ...sheetEn,
        ...sidebarEn,
        ...siteLogoEn,
        ...skeletonEn,
        ...sliderEn,
        ...snackBarEn,
        ...statTileEn,
        ...stateCardEn,
        ...stepperEn,
        ...stickerEn,
        ...swipeableRowEn,
        ...systemToolbarEn,
        ...tabBarEn,
        ...tableEn,
        ...tabsEn,
        ...textEn,
        ...textAreaInputEn,
        ...textInputEn,
        ...themeSwitcherEn,
        ...timeSelectorEn,
        ...timelineEn,
        ...toastEn,
        ...toggleEn,
        ...toggleGroupEn,
        ...tooltipEn,
        ...traceEn,
        ...treeViewEn,
        ...userShortcutEn,
        ...webScrollbarEn,
        ...yearSelectorEn
    },
    tr: {
        ...accordionTr,
        ...alertTr,
        ...animatedIconTr,
        ...areaChartTr,
        ...aspectRatioTr,
        ...attachmentTr,
        ...avatarTr,
        ...avatarGroupTr,
        ...barChartTr,
        ...bottomSheetTr,
        ...brandIconsTr,
        ...breadcrumbTr,
        ...bubbleTr,
        ...buttonTr,
        ...buttonGroupTr,
        ...cardTr,
        ...carouselTr,
        ...chartTr,
        ...checkBoxTr,
        ...chipTr,
        ...citationTr,
        ...codeEditorTr,
        ...codeViewerTr,
        ...collapsibleTr,
        ...colorAreaTr,
        ...colorFieldTr,
        ...colorPickerTr,
        ...colorSliderTr,
        ...colorSwatchTr,
        ...colorSwatchPickerTr,
        ...comboboxTr,
        ...commandTr,
        ...composerTr,
        ...contextMenuTr,
        ...dataTableTr,
        ...dateSelectorTr,
        ...dateTimePickerTr,
        ...dateTimeSheetTr,
        ...dialogTr,
        ...directionProviderTr,
        ...dropdownMenuTr,
        ...embeddedMenuTr,
        ...fieldTr,
        ...fileUploadTr,
        ...flagTr,
        ...headerTr,
        ...highlightButtonTr,
        ...hoverCardTr,
        ...iconTr,
        ...itemTr,
        ...inputGroupTr,
        ...inputOTPTr,
        ...kbdTr,
        ...lineChartTr,
        ...loadingTr,
        ...localeSwitcherTr,
        ...mainHeaderTr,
        ...markdownEditorTr,
        ...markdownViewerTr,
        ...markerTr,
        ...menuTr,
        ...menubarTr,
        ...messageTr,
        ...messageScrollerTr,
        ...modalTr,
        ...monthSelectorTr,
        ...nativeSelectTr,
        ...navigationMenuTr,
        ...notificationIndicatorTr,
        ...numericInputTr,
        ...pageContainerTr,
        ...paginationTr,
        ...paletteSwitcherTr,
        ...pieChartTr,
        ...radarChartTr,
        ...radialChartTr,
        ...sparklineTr,
        ...popoverTr,
        ...progressTr,
        ...questionnaireTr,
        ...radioButtonTr,
        ...resizableTr,
        ...radioGroupTr,
        ...badgeTr,
        ...labelTr,
        ...emptyTr,
        ...scrollAreaTr,
        ...rowCardTr,
        ...selectBoxTr,
        ...selectSheetTr,
        ...separatorTr,
        ...sheetTr,
        ...sidebarTr,
        ...siteLogoTr,
        ...skeletonTr,
        ...sliderTr,
        ...snackBarTr,
        ...statTileTr,
        ...stateCardTr,
        ...stepperTr,
        ...stickerTr,
        ...swipeableRowTr,
        ...systemToolbarTr,
        ...tabBarTr,
        ...tableTr,
        ...tabsTr,
        ...textTr,
        ...textAreaInputTr,
        ...textInputTr,
        ...themeSwitcherTr,
        ...timeSelectorTr,
        ...timelineTr,
        ...toastTr,
        ...toggleTr,
        ...toggleGroupTr,
        ...tooltipTr,
        ...traceTr,
        ...treeViewTr,
        ...userShortcutTr,
        ...webScrollbarTr,
        ...yearSelectorTr
    }
};
